import { render, staticRenderFns } from "./WorkDetails.vue?vue&type=template&id=b3937d6a&scoped=true&"
import script from "./WorkDetails.vue?vue&type=script&lang=js&"
export * from "./WorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetails.vue?vue&type=style&index=0&id=b3937d6a&lang=scss&scoped=true&"
import style1 from "./WorkDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3937d6a",
  null
  
)

export default component.exports